import styled from "styled-components"

const StyledButton = styled.button`
    height: 50px;
    background-color: ${props => props.bgColor};
    color: ${props => props.color};
    border: none;
    border-radius: 10px;
    transition: background-color 0.2s;
    opacity: ${props => props.disabled ? 0.5 : 1};
    line-height: 15px;

    &:hover{
        background-color: ${props => props.disabled ? props.bgColor : props.hover};
    }
    &:focus{
        outline: none;
    }
`;
export function CustomButton(props) {
    return (
        <StyledButton
            {...props}
        >
            {props.children}
        </StyledButton>
    );
}
